import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import "../styles/AssessmentForm.css";

import 'react-toastify/dist/ReactToastify.css';

export default function HrAssessmentForm({ initialData = null, onCancel, onSave }) {
     const submittingRef = useRef(false);
     const baseUrl = process.env.REACT_APP_BASE_URL;

     const navigate = useNavigate();
     const [isSubmitting, setIsSubmitting] = useState(false);
     const [modalities, setModalities] = useState([]);
     const [selectedRegions, setSelectedRegions] = useState({});
     const [status, setStatus] = useState('');

     const [personal, setPersonal] = useState({
          positionApplied: "",
          candidateName: "",
          mobile: "",
          email: "",
          qualification: "",
          registration: "",
          paediatric: "",
          totalExperience: "",
          department: "",
          vdcLocation: "",
          typeOfAssociation: "",
          timingsFrom: "",
          timingsTo: "",
          hr_status: "",
     });
     function onCancel() {
          navigate('/hr-radiology-assessment'); // ✅ redirect to the route
     }
     const [errors, setErrors] = useState({});

     useEffect(() => {
          if (initialData) {
               setPersonal((p) => ({
                    ...p,
                    positionApplied: initialData.positionApplied || initialData.appliedPosition || p.positionApplied,
                    candidateName: initialData.candidateName || initialData.name || p.candidateName,
                    mobile: initialData.mobile || initialData.phone || "99999 00000",
                    email: initialData.email || initialData.contactEmail || "candidate@example.com",
                    qualification: initialData.qualification || initialData.eduQualification || "MBBS, MD Radiology",
                    registration: initialData.registration || initialData.stateRegistration || "Yes",
                    paediatric: initialData.paediatric || initialData.paediatric || "Yes",
                    totalExperience: initialData.totalExperience || initialData.experienceYears || "6",
                    department: initialData.department || initialData.dept || "Radiology",
                    vdcLocation: initialData.vdcLocation || initialData.location || "Mumbai",
                    typeOfAssociation: initialData.typeOfAssociation || initialData.associationType || "Full Time",
                    timingsFrom: initialData.timingsFrom || initialData.shiftStart || "09:00",
                    timingsTo: initialData.timingsTo || initialData.shiftEnd || "17:00",
                    hr_status: initialData.hr_status || 'Pending',
               }));
          }
     }, [initialData]);

     function handlePersonalChange(e) {
          const { name, value } = e.target;
          setPersonal((p) => ({ ...p, [name]: value }));
     }
     async function handleSubmit(e) {

          e.preventDefault();
          if (isSubmitting) {
               return; // Prevent multiple submissions
          }
          if (submittingRef.current) return;

          submittingRef.current = true; // lock submission immediately
          setIsSubmitting(true);        // disable button visually
          const payload = {
               personal,

          };
          setIsSubmitting(true);
          try {
               const response = await fetch(`${baseUrl}/hr_personal_assessment_form`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${sessionStorage.getItem("token")}`, },
                    body: JSON.stringify(payload),
               });

               if (!response.ok) {
                    const error = await response.json();
                    console.error("API error:", error);
                    alert("Submission failed.");
                    return;
               }

               const result = await response.json();
               navigate("/hr-radiology-assessment", {
                    state: { successMessage: "Assessment successfully added!" },
               });

          } catch (err) {
               console.error("Submit failed:", err);
               alert("Network or server error.");
          } finally {
               submittingRef.current = false;
               setIsSubmitting(false);
          }
     }

     const cardStyle = {
          background: "#fff",
          padding: "5px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgb(0 0 0 / 0.1)",
          marginBottom: "5px",
     };
     const grid4Columns = {
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "5px",
          alignItems: "start",
     };

     return (
          <form onSubmit={handleSubmit}>
               <div
                    style={{
                         minHeight: "40vh",
                         padding: 5,
                         overflowY: "auto",
                         backgroundColor: "#f9f9f9",
                         boxSizing: "border-box",
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "flex-start",

                    }}
               >
                    <div
                         style={{
                              width: "100%",
                              maxWidth: "100%",
                              boxSizing: "border-box",

                         }}
                    >
                         <div className="form-section" style={cardStyle}>
                              <div className="section-title" style={{ marginBottom: "5px" }}>
                                   Personal Details
                              </div>

                              <div style={grid4Columns}>
                                   <label>
                                        Position Applied
                                        <input
                                             className="form-control input-form"
                                             name="positionApplied"
                                             value={personal.positionApplied}
                                             onChange={handlePersonalChange}
                                             required
                                        />
                                        {errors["personal.positionApplied"] && (
                                             <div className="field-error">{errors["personal.positionApplied"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Candidate Name
                                        <input
                                             className="form-control input-form"
                                             name="candidateName"
                                             value={personal.candidateName}
                                             onChange={handlePersonalChange}
                                             required
                                        />
                                        {errors["personal.candidateName"] && (
                                             <div className="field-error">{errors["personal.candidateName"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Mobile
                                        <input
                                             className="form-control input-form"
                                             name="mobile"
                                             type="text"
                                             value={personal.mobile}
                                             maxLength={10} // optional
                                             required
                                             onChange={(e) => {
                                                  // Filter only digits from the input value
                                                  const onlyNums = e.target.value.replace(/\D/g, "");
                                                  // Call your handler with a synthetic event-like object
                                                  handlePersonalChange({
                                                       target: {
                                                            name: e.target.name,
                                                            value: onlyNums,
                                                       },
                                                  });
                                             }}
                                        />
                                        {errors["personal.mobile"] && (
                                             <div className="field-error">{errors["personal.mobile"]}</div>
                                        )}
                                   </label>
                                   <label>
                                        Email
                                        <input
                                             className="form-control input-form"
                                             name="email"
                                             type="email"  // <-- Add this
                                             value={personal.email}
                                             onChange={handlePersonalChange}
                                             required
                                        />
                                        {errors["personal.email"] && (
                                             <div className="field-error">{errors["personal.email"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Educational Qualification
                                        <input
                                             className="form-control input-form"
                                             required
                                             name="qualification"
                                             value={personal.qualification}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.qualification"] && (
                                             <div className="field-error">{errors["personal.qualification"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Department
                                        <input
                                             className="form-control input-form"
                                             required
                                             name="department"
                                             value={personal.department}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.department"] && (
                                             <div className="field-error">{errors["personal.department"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Relevant State Medical Registration
                                        <select
                                             className="form-control input-form"
                                             required
                                             name="registration"
                                             value={personal.registration}
                                             onChange={handlePersonalChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             <option>Yes</option>
                                             <option>No</option>
                                        </select>
                                        {errors["personal.registration"] && (
                                             <div className="field-error">{errors["personal.registration"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Paediatric
                                        <select
                                             className="form-control input-form"
                                             required
                                             name="paediatric"
                                             value={personal.paediatric}
                                             onChange={handlePersonalChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             <option>Yes</option>
                                             <option>No</option>
                                        </select>
                                        {errors["personal.paediatric"] && (
                                             <div className="field-error">{errors["personal.paediatric"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Total Experience (In Yrs.)
                                        <input
                                             className="form-control input-form"
                                             required
                                             name="totalExperience"
                                             value={personal.totalExperience}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.totalExperience"] && (
                                             <div className="field-error">{errors["personal.totalExperience"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        VDC Location (Applied for)
                                        <input
                                             className="form-control input-form"
                                             required
                                             name="vdcLocation"
                                             value={personal.vdcLocation}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.vdcLocation"] && (
                                             <div className="field-error">{errors["personal.vdcLocation"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Timings From
                                        <input
                                             required
                                             type="time"
                                             className="form-control input-form"
                                             name="timingsFrom"
                                             min="07:00"
                                             max="23:00"
                                             value={personal.timingsFrom}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.timingsFrom"] && (
                                             <div className="field-error">{errors["personal.timingsFrom"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Timings To
                                        <input
                                             required
                                             type="time"
                                             min="07:00"
                                             max="23:00"
                                             className="form-control input-form"
                                             name="timingsTo"
                                             value={personal.timingsTo}
                                             onChange={handlePersonalChange}
                                        />
                                        {errors["personal.timingsTo"] && (
                                             <div className="field-error">{errors["personal.timingsTo"]}</div>
                                        )}
                                   </label>

                                   <label>
                                        Type of Association
                                        <select
                                             className="form-control input-form"
                                             name="typeOfAssociation"
                                             value={personal.typeOfAssociation}
                                             required
                                             onChange={handlePersonalChange}
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">-- Select --</option>
                                             <option value="Full Time">Full Time</option>
                                             <option value="Part Time">Part Time</option>
                                             <option value="Target Model">Target Model</option>
                                             <option value="Base">Base</option>
                                        </select>

                                        {errors["personal.typeOfAssociation"] && (
                                             <div className="field-error">{errors["personal.typeOfAssociation"]}</div>
                                        )}
                                   </label>

                                   <label>Hr Status
                                        <select
                                             className="form-control input-form"
                                             name="hr_status"
                                             value={personal.hr_status}
                                             onChange={(e) =>
                                                  setPersonal({ ...personal, hr_status: e.target.value })
                                             }
                                             style={{ height: "32px", width: "100%", padding: "0px 18px" }}
                                        >
                                             <option value="">Select Status</option>
                                             <option value="Pending">Pending</option>
                                             <option value="Approved">Approved</option>
                                        </select>
                                   </label>
                              </div>
                         </div>
                    </div>
               </div>

               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0px" }}>
                    <div className="small-muted">All fields are mandatory.</div>
                    <div className="form-actions">
                         <button
                              type="button"
                              className="btn"
                              style={{ background: "#9CA3AF" }}
                              onClick={onCancel}
                              disabled={isSubmitting}
                         >
                              Cancel
                         </button>
                         <button
                              type="submit"
                              className="btn btn-warning pull-right"
                              disabled={isSubmitting}
                         >
                              {isSubmitting ? "Saving..." : "Save Assessment"}
                         </button>
                    </div>
               </div>
          </form>
     );
}